import React from "react";
import { CheckCircle2, ScrollText } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";
import { rules } from "../mock";

const RulesDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass border-emerald-500/20 text-white max-w-2xl p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-emerald-500/10">
          <div className="flex items-center gap-2 mb-1">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500/15 ring-1 ring-emerald-400/30">
              <ScrollText className="h-4 w-4 text-emerald-400" />
            </span>
            <DialogTitle className="font-display text-xl">
              Competition <span className="text-emerald-400">Rules</span>
            </DialogTitle>
          </div>
          <DialogDescription className="text-slate-400">
            Everything you need to know to compete fairly and get paid.
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="max-h-[65vh] px-6 py-5">
          <div className="grid grid-cols-1 gap-4">
            {rules.map((r) => (
              <div key={r.title} className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
                <h3 className="font-display text-base font-semibold text-emerald-300 mb-2">
                  {r.title}
                </h3>
                <p className="text-sm leading-relaxed text-slate-400">{r.body}</p>
                {r.bullets && (
                  <ul className="mt-4 space-y-2">
                    {r.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2 text-sm text-slate-300">
                        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default RulesDialog;
